<template>

  <b-container class="pb-5">
    <b-row class="justify-content-right p-5">
      <slot name="p-1"></slot>
    </b-row>

    <b-row class="justify-content-center px-3 py-5" v-if="getProducts != null">
      <b-col lg="4" md="6" sm="12" v-for="product in getProducts" :key="product.id" class="py-1">
        <m-c103 :product="product" class="h-100"/>
      </b-col>
    </b-row>

    <b-row>
      <div class="ml-auto mr-auto">
        <m-pagination-400 v-if="havePagination" :meta="paginationMeta" :on-change-page="changePage"/>
      </div>

      <slot name="more"/>
    </b-row>
  </b-container>

</template>

<script>
import {mapGetters} from "vuex";
import router from "@/router";


export default {
  name: "OfferProducts100",
  props: ["showNumber", "havePagination"],
  computed: {
    ...mapGetters({
      products: 'Product/getOfferProducts',
      paginationMeta: "Content/getPaginationMeta",
    }),
    getProducts() {
      if (this.showNumber) {
        const products = this.products;
        return products.slice(0, this.showNumber)
      } else {
        return this.products
      }
    },
  },
  methods: {
    filterBySortOrder(order) {
      this.$store.commit("Product/setFilters", {
        key: "sort",
        value: order,
      });
      router.push({
        name: "Products",
        query: {...router.currentRoute.query, sort: order},
      });
      this.filterAction();
    },
    filterAction() {
      if (
          this.$store.getters["Product/getFilter"]("search").trim().length == 0
      ) {
        this.$store.dispatch("Product/setProducts", 1);
      } else {
        this.$store.dispatch("Product/filteredProducts");
      }
    },
    changePage(page) {
      this.$store.dispatch("Product/setProducts", page);
      router.push({name: "Products", query: {...router.currentRoute.query, page: page}})
    }
  },
  async mounted() {
    await this.$store.dispatch('Product/getOfferProducts')
  }
}
</script>

<style scoped>

</style>